module.exports = __webpack_public_path__ + "img/iconHistory.5af1a9e9.svg";